// D:\brickbucket_v3.1\Brickbucket_Frontend_V3.1\src\ConsumerApp\api\projects\project.service.js

import { apiClient } from '../apiClient';

export const ProjectService = {
  getProjectsByCustomer: async (customerId) => {
    if (!customerId) throw new Error('Customer ID is required');
    const response = await apiClient.get(
      `/brickbucket/customer/get-projects-by-buyer?customer_id=${customerId}`
    );
    return response;
  },

  getDefaultDeliveryAddress: async (customerId) => {
    if (!customerId) throw new Error('Customer ID is required');
    const response = await apiClient.get(
      `/brickbucket/customer/delivery-address/getDefaultDeliveryAddress?customer_id=${customerId}`
    );
    return response;
  },

  selectDeliveryAddressForCustomer: async (data) => {
    const response = await apiClient.post(
      '/brickbucket/customer/delivery-address/select-active-delivery-address',
      data
    );
    return response;
  },

  createProject: async (projectData) => {
    const response = await apiClient.post('/measuritV3/projects/create-project', projectData);
    return response;
  },

  updateProject: async ({ projectId, payload }) => {
    if (!projectId) throw new Error('Project ID is required');
    const response = await apiClient.put(
      `/measuritV3/projects/update-project?projectId=${projectId}`,
      payload
    );
    return response;
  },

  deleteProject: async (projectId) => {
    if (!projectId) throw new Error('Project ID is required');
    const response = await apiClient.delete(
      `/measuritV3/projects/delete-project?projectId=${projectId}`
    );
    return response;
  },
};